import { SELECT_AREA } from '../actions/index.js';

const INITIAL_STATE = {
  data: null,
};

const area = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECT_AREA:
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default area;



/** WEBPACK FOOTER **
 ** ./src/reducers/area.js
 **/